const element = document.getElementById('events');

if (typeof (element) !== 'undefined' && element != null) {
	// function to change reveal all past events
	document.addEventListener('click', (event) => {
		if (!event.target.matches('.events-loadmore')) return;
		event.preventDefault();

		const allPastEvents = document.getElementsByClassName('past-item-wrapper');
		[].forEach.call(allPastEvents, (elem) => { // eslint-disable-line no-param-reassign
			elem.className += ' active'; // eslint-disable-line no-param-reassign
		});

		const loadMore = document.getElementById('events-loadmore');
		loadMore.style.display = 'none';
	}, false);
}
